import { render } from "./VueImageVerify.vue?vue&type=template&id=4fb1ccb4"
import script from "./VueImageVerify.vue?vue&type=script&lang=js"
export * from "./VueImageVerify.vue?vue&type=script&lang=js"

import "./VueImageVerify.vue?vue&type=style&index=0&id=4fb1ccb4&lang=css"
script.render = render

export default script